export const queryKeys = {
  cars: {
    all: ['cars'] as const,
    queueAll: ['cars', 'queue'] as const,
    queue: (params: Record<string, unknown>) => ['cars', 'queue', params] as const,
    list: (params: Record<string, unknown>) => ['cars', 'list', params] as const,
    search: (params: Record<string, unknown>) => ['cars', 'search', params] as const,
    filter: (params: Record<string, unknown>) => ['cars', 'filter', params] as const,
    detail: (id: string) => ['cars', 'detail', id] as const,
    // at-130: sob `cars` de propósito — o socket de mudança de esteira invalida `cars.all`.
    kanbanRegua: (ids: string[]) => ['cars', 'kanban-regua', ids] as const,
  },
  parts: {
    all: ['parts'] as const,
    list: (params: Record<string, unknown>) => ['parts', 'list', params] as const,
    byCar: (params: Record<string, unknown>) => ['parts', 'by-car', params] as const,
    search: (params: Record<string, unknown>) => ['parts', 'search', params] as const,
    detail: (id: string) => ['parts', 'detail', id] as const,
    logs: (params: Record<string, unknown>) => ['parts', 'logs', params] as const,
  },
  atividadesCarro: {
    all: ['atividades-carro'] as const,
    list: (params: Record<string, unknown>) => ['atividades-carro', 'list', params] as const,
  },
  workSessions: {
    all: ['work-sessions'] as const,
    list: (params: Record<string, unknown>) => ['work-sessions', 'list', params] as const,
  },
  audit: {
    all: ['audit'] as const,
    collaborators: ['audit', 'collaborators'] as const,
    carsSearch: (params: Record<string, unknown>) => ['audit', 'cars-search', params] as const,
    carDetail: (params: Record<string, unknown>) => ['audit', 'car-detail', params] as const,
  },
  // at-48b: janelas de pausa automática vigentes (bloqueio das ações no horário).
  pausasAutomaticas: {
    vigentes: ['pausas-automaticas', 'vigentes'] as const,
  },
  orcamentoCilia: {
    all: ['orcamento-cilia'] as const,
    list: (params: Record<string, unknown>) => ['orcamento-cilia', 'list', params] as const,
    detail: (id: string) => ['orcamento-cilia', 'detail', id] as const,
    defaults: ['orcamento-cilia', 'defaults'] as const,
    produtoDepara: (params: Record<string, unknown>) => ['orcamento-cilia', 'produto-depara', params] as const,
    autorizacoesPendentes: (params: Record<string, unknown>) =>
      ['orcamento-cilia', 'autorizacoes-pendentes', params] as const,
    autorizacoesPendentesCount: ['orcamento-cilia', 'autorizacoes-pendentes-count'] as const,
    notificacoes: ['orcamento-cilia', 'notificacoes'] as const,
    historico: (id: string) => ['orcamento-cilia', 'historico', id] as const,
    // at-11: cadastros do ERP que a conferência e a configuração consultam.
    unidades: ['orcamento-cilia', 'unidades-nasajon'] as const,
    usuarioDepara: ['orcamento-cilia', 'usuario-depara'] as const,
    meuVinculoNasajon: ['orcamento-cilia', 'usuario-depara', 'meu'] as const,
  },
};
